import { IGetNewbuildingDeveloperValuationResponse } from '../../repositories/newbuilding-estimate/entities/newbuilding_developer_valuation/GetNewbuildingDeveloperValuationResponse';
import { IDeveloperValuationState } from '../../types/developerValuation/developerValuationState';

export type TDeveloperValuationPreparedData = Partial<IDeveloperValuationState>;

export const prepareDeveloperValuationState = (
  res: IGetNewbuildingDeveloperValuationResponse | null,
): TDeveloperValuationPreparedData | null => {
  if (!res) {
    return null;
  }

  return {
    pricesFiltersState: {
      buildingClass: res.filters.activeBuildingClass,
      period: res.filters.activePeriod,
      roomCount: res.filters.activeRoomCount,
      regionId: res.filters.activeRegionId,
    },
    developerValuation: {
      chart: res.chart,
      filters: res.filters,
      priceDynamics: res.priceDynamics ?? undefined,
    },
  };
};
